<template>
  <div class="receive-list">
    <c-table ref="table" :columns="columns" url="/emailj/list" :defaultParam="{id: fetchId}">
      <el-table-column slot="gongid" show-overflow-tooltip label="工号">
        <template v-slot="{row}">
          <span>{{row.gongid}}</span>
        </template>
      </el-table-column>
      <el-table-column slot="name" show-overflow-tooltip label="姓名">
        <template v-slot="{row}">
          <span>{{row.name}}</span>
        </template>
      </el-table-column>
      <el-table-column slot="param" show-overflow-tooltip label="变量">
        <template v-slot="{row}">
          <span>{{row.param}}</span>
        </template>
      </el-table-column>
    </c-table>
  </div>
</template>
<script>
import CTable from '@/components/common/table'
import mixin from '@/mixins'
import qs from 'qs'
export default {
  mixins: [ mixin ],
  components: { CTable },
  data () {
    return {
      columns: [
        { slot: 'gongid' },
        { slot: 'name' },
        { slot: 'param' }
      ],
      fetchId: null
    }
  },
  created () {
    const search = qs.parse(location.search, { ignoreQueryPrefix: true })
    const id = 'id' in search ? search.id : null
    if (!id) {
      this.$router.push('/email')
      return false
    }
    this.fetchId = parseInt(id)
  }
}
</script>
<style lang="scss" scoped>
.upload-input {
  padding: 20px 0;
  .mission-name {
    width: 200px;
    margin-right: 10px;
  }
  button {
    height: 32px;
  }
}
</style>
